import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ThreeCircles } from "react-loader-spinner";
import { BsSearch } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";
import { fetchUsers, fetchSearch, fetchSearchHome } from '../redux/fetchUser';
import Modal from 'react-modal';
import Select from "react-select";
import axios from 'axios';

const renderValue = (value) =>
  value !== undefined && value !== null && value !== '' ? value : '-';


function NavbarTop() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const items = useSelector((state) => state.items);
  const datahome = useSelector((state) => state.datahome);

  const [catList, setCat] = useState([]);
  const [opdList, setOpd] = useState([]);
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [dataDisplayView, setDataDisplayView] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedYear, setSelectedYear] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedInstansi, setSelectedInstansi] = useState(null);

  const videoEl = useRef(null);

  // Scroll to target after loading
  const handleScroll = () => {
    const element = document.getElementById('targetElement');
    if (element) {
      const offset = 45;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const offsetPosition = elementRect - bodyRect - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    document.getElementById('dokumen').value = '';
    document.getElementById('status_dokumen').value = '';
    document.getElementById('nomordoc').value = '';
    setSelectedCategory(null);
    setSelectedInstansi(null);
    setSelectedYear('');
  };

  // Search function
  const handleSearch = async () => {
    const dokumen = document.getElementById('dokumen').value;
    const kategori = selectedCategory?.value || '';
    const instansi = selectedInstansi?.value || '';
    const tahun = selectedYear || '';
    const status_dokumen = document.getElementById('status_dokumen').value;
    const nomordoc = document.getElementById('nomordoc').value;

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/documents?nomor=${nomordoc}&dokumen=${dokumen}&kategori=${kategori}&tahun=${tahun}&status_dokumen=${status_dokumen}&instansi=${instansi}`
    )
      .then((res) => res.json())
      .then((res) => {
        dispatch(fetchSearchHome(res.data));
        setDataToDisplay(res.data);
      });

    setDataDisplayView(dokumen || kategori || status_dokumen || instansi ? 1 : 0);

    dispatch(
      fetchUsers({
        dokumen_filter: dokumen,
        kategori_filter: kategori,
        instansi_filter: instansi,
        tahun_filter: tahun,
        status_dokumen_filter: status_dokumen,
        nomor_doc_filter: nomordoc,
      })
    );
    openModal();
  };

  const handleSearchPageNext = async (e) => {
    const dokumen = document.getElementById('dokumen').value;
    const kategori = selectedCategory?.value || '';
    const instansi = selectedInstansi?.value || '';
    const tahun = selectedYear || '';
    const status_dokumen = document.getElementById('status_dokumen').value;
    const nomordoc = document.getElementById('nomordoc').value;

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/documents?nomor=${nomordoc}&dokumen=${dokumen}&kategori=${kategori}&tahun=${tahun}&status_dokumen=${status_dokumen}&page=${e}`
    )
      .then((res) => res.json())
      .then((res) => {
        dispatch(fetchSearchHome(res.data));
        setDataToDisplay(res.data);
      });
  };

  const getCategories = async () => {
    const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/categories`);
    const data = await res.json();
    //console.log('Categories dari API:', data.data); // <-- cek ini
    setCat(data.data);
  };

  const getOpd = async () => {
    const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/opd`);
    const data = await res.json();
    setOpd(data.data);
  };

  const inisiateFilter = () => {
    dispatch(
      fetchUsers({
        dokumen_filter: '',
        kategori_filter: '',
        instansi_filter: '',
        tahun_filter: '',
        status_dokumen_filter: '',
        nomor_doc_filter: '',
      })
    );
  };

  const SearchableSelect = ({
    options = [],
    value = null,
    onChange,
    placeholder = 'Pilih...',
    className = '',
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const inputRef = useRef(null);
    const wrapperRef = useRef(null);

    const filteredOptions = options.filter(opt =>
      opt?.label && opt.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSelect = (option) => {
      onChange(option);
      setIsOpen(false);
      setSearchTerm('');
    };

    const toggleDropdown = () => {
      if (!isOpen) setSearchTerm('');
      setIsOpen(!isOpen);
    };

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
          setIsOpen(false);
          setSearchTerm('');
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
      if (isOpen && inputRef.current) {
        inputRef.current.focus();
      }
    }, [isOpen]);

    const selectedLabel = value?.label || '';

    return (
      <div ref={wrapperRef} className={`relative w-full ${className}`}>
        <div
          onClick={toggleDropdown}
          className="w-full px-4 rounded-xl bg-white text-gray-800 border border-gray-200 cursor-pointer flex items-center justify-between hover:border-gray-300 transition overflow-hidden"
          style={{ height: '52px' }}
        >
          <span className={`${selectedLabel ? 'text-gray-800' : 'text-gray-400'} truncate flex-1 min-w-0`}>
            {selectedLabel || placeholder}
          </span>
          <svg className="w-4 h-4 text-gray-400 flex-shrink-0 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        {isOpen && (
          <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
            <div className="p-2 border-b border-gray-100">
              <input
                ref={inputRef}
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Cari..."
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            <div className="max-h-60 overflow-y-auto py-1">
              {options.length === 0 ? (
                <div className="px-4 py-3 text-gray-400 text-sm">Memuat data...</div>
              ) : filteredOptions.length > 0 ? (
                filteredOptions.map((opt) => (
                  <div
                    key={opt.value}
                    onClick={() => handleSelect(opt)}
                    className={`px-4 py-2 cursor-pointer hover:bg-gray-100 text-gray-800 ${value?.value === opt.value ? 'bg-blue-50 text-blue-600' : ''
                      }`}
                  >
                    {opt.label}
                  </div>
                ))
              ) : (
                <div className="px-4 py-3 text-gray-400 text-sm">
                  {searchTerm ? `Tidak ada hasil untuk "${searchTerm}"` : 'Tidak ada data'}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
      if (videoEl.current) {
        videoEl.current.play().catch(() => { });
      }
    }, 4000);
    inisiateFilter();
    getCategories();
    getOpd();
  }, []);

  return (
    <nav className="relative w-full min-h-screen bg-[#0889c1] overflow-hidden">
      {/* Video Background */}
      <video
        className="absolute inset-0 w-full h-full object-cover opacity-40"
        playsInline
        loop
        muted
        ref={videoEl}
        src="https://bo.jdih.magelangkota.go.id/mvideo_01.mp4"
      />
      {/* Overlay gradasi */}
      <div className="absolute inset-0 bg-gradient-to-b from-blue-900/70 via-blue-800/50 to-transparent" />

      {/* Konten utama */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-8 text-white">
        {/* Logo dan judul */}
        <div className="flex flex-col items-center mb-8">
          <img
            src="https://bo.jdih.magelangkota.go.id/logo-header.png"
            alt="JDIH Logo"
            className="h-20 md:h-28 w-auto drop-shadow-lg"
          />
          <h1 className="text-2xl md:text-1xl font-serif font-bold mt-3 text-center tracking-wide drop-shadow-lg bg-gradient-to-r from-amber-200 via-yellow-300 to-orange-400 bg-clip-text text-transparent">
            Jaringan Dokumentasi dan Informasi Kota Magelang
          </h1>
        </div>

        {/* Form Pencarian - Glassmorphism */}
        {/* Form Pencarian - Glassmorphism */}
        <div className="w-full max-w-5xl bg-white/10 backdrop-blur-lg rounded-2xl p-6 shadow-2xl border border-white/20">
          <h2 className="text-center font-semibold text-white text-lg mb-4 tracking-wide">
            SILAHKAN CARI DOKUMEN
          </h2>

          <div className="space-y-4">
            {/* Kata Kunci */}
            <input
              id="dokumen"
              defaultValue={items?.data?.dokumen_filter || ''}
              type="text"
              placeholder="Masukkan Kata Kunci"
              className="w-full h-[52px] px-4 rounded-xl bg-white/90 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
            />

            {/* Grid 5 kolom */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
              {/* Kategori */}
              <SearchableSelect
                options={catList.map((c) => ({ value: c.value, label: c.label }))}
                value={selectedCategory}
                onChange={setSelectedCategory}
                placeholder="Kategori"
                className="w-full"
              />

              {/* Nomor */}
              <input
                id="nomordoc"
                defaultValue={items.data?.nomor_doc_filter || ''}
                type="text"
                placeholder="Nomor"
                className="w-full h-[52px] px-4 rounded-xl bg-white/90 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              />

              {/* Tahun */}
              <input
                type="text"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                placeholder="Tahun"
                className="w-full h-[52px] px-4 rounded-xl bg-white/90 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              />

              {/* Instansi */}
              <SearchableSelect
                options={opdList.map((o) => ({ value: o.value, label: o.label }))}
                value={selectedInstansi}
                onChange={setSelectedInstansi}
                placeholder="Cari Instansi"
                className="w-full"
              />

              {/* Status + Tombol Cari */}
              <div className="flex gap-2">
                <select
                  id="status_dokumen"
                  defaultValue={items.data?.status_dokumen_filter || ''}
                  className="flex-1 h-[52px] px-4 rounded-xl bg-white/90 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                >
                  <option value="">Status</option>
                  <option value="1">Berlaku</option>
                  <option value="2">Mencabut</option>
                  <option value="3">Dicabut</option>
                  <option value="4">Mengubah</option>
                  <option value="5">Diubah</option>
                </select>
                <button
                  onClick={handleSearch}
                  className="h-[52px] w-[52px] bg-red-600 hover:bg-red-700 text-white rounded-xl transition shadow-md hover:shadow-lg flex items-center justify-center flex-shrink-0"
                >
                  <BsSearch size={20} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Tombol scroll atau loading */}
        <div className="mt-10">
          {isLoading ? (
            <ThreeCircles
              visible={true}
              height="80"
              width="80"
              color="#e23d28"
              ariaLabel="loading"
            />
          ) : (
            <button
              onClick={handleScroll}
              className="animate-bounce bg-white/20 backdrop-blur-sm p-3 rounded-full hover:bg-white/30 transition"
            >
              <img
                src="https://img.icons8.com/?size=60&id=34t07djcWeVX&format=png&color=000000"
                alt="Scroll down"
                className="w-12 h-12"
              />
            </button>
          )}
        </div>
      </div>

      {/* Modal Hasil Pencarian */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Hasil Pencarian"
        style={{
          overlay: { backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 50 },
          content: {
            maxWidth: '95%',
            maxHeight: '82%',
            margin: 'auto',
            borderRadius: '1.5rem',
            padding: '1.5rem',
            background: '#f9fafb',
            border: 'none',
            boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)',
          },
        }}
      >
        <div className="flex flex-col h-full">
          <div className="flex-1 overflow-y-auto">
            {dataDisplayView === 0 ? (
              // Tampilan Tabel
              <>
                {datahome?.data?.data ? (
                  <div className="overflow-x-auto">
                    <div className="text-sm text-gray-600 mb-3">
                      Halaman : {renderValue(datahome.data.current_page)}
                    </div>
                    <table className="w-full text-sm text-left">
                      <thead className="bg-gray-100 text-gray-700 text-xs uppercase tracking-wider rounded-lg">
                        <tr>
                          <th className="px-4 py-3 rounded-l-lg">NO</th>
                          <th className="px-4 py-3">JUDUL</th>
                          <th className="px-4 py-3">JENIS</th>
                          <th className="px-4 py-3">NOMOR</th>
                          <th className="px-4 py-3">TAHUN</th>
                          <th className="px-4 py-3 rounded-r-lg">DETAIL</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {datahome.data.data.map((field, index) => {
                          const currentPage = datahome.data.current_page || 1;
                          const perPage = datahome.data.per_page || 10;
                          const rowNum =
                            currentPage === 1
                              ? index + 1
                              : (currentPage - 1) * perPage + index + 1;
                          return (
                            <tr key={field.id} className="hover:bg-gray-50 transition">
                              <td className="px-4 py-3 text-gray-500">{rowNum}</td>
                              <td className="px-4 py-3 font-medium text-gray-800">
                                {renderValue(field.content)}
                              </td>
                              <td className="px-4 py-3 text-gray-600">
                                {renderValue(field.nama)}
                              </td>
                              <td className="px-4 py-3 text-gray-600">
                                {renderValue(field.no_peraturan)}
                              </td>
                              <td className="px-4 py-3 text-gray-600">
                                {renderValue(field.tahun_diundang)}
                              </td>
                              <td className="px-4 py-3">
                                <Link to={`/detail-produk-hukum/${field.idph}`}>
                                  <button className="px-4 py-1.5 text-sm font-medium text-red-600 border border-red-600 rounded-lg hover:bg-red-600 hover:text-white transition">
                                    Lihat
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {/* Pagination */}
                    <div className="flex justify-center mt-6">
                      <nav aria-label="Page navigation">
                        <ul className="flex items-center -space-x-px text-sm">
                          <li>
                            <a
                              href="#"
                              className="px-3 py-2 rounded-l-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500"
                            >
                              Previous
                            </a>
                          </li>
                          {datahome.data?.links?.map((link, idx) => {
                            const label = link.label;
                            if (label !== 'pagination.previous' && label !== 'pagination.next') {
                              return (
                                <li key={idx}>
                                  <a
                                    href="#"
                                    onClick={() => handleSearchPageNext(label)}
                                    className={`px-3 py-2 border border-gray-200 bg-white hover:bg-gray-50 ${dataToDisplay.current_page === label
                                        ? 'bg-red-600 text-white hover:bg-red-700'
                                        : 'text-gray-500'
                                      }`}
                                  >
                                    {renderValue(label)}
                                  </a>
                                </li>
                              );
                            }
                            return null;
                          })}
                          <li>
                            <a
                              href="#"
                              className="px-3 py-2 rounded-r-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500"
                            >
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-center py-10">
                    <ThreeCircles visible height="50" width="50" color="#dc2626" />
                  </div>
                )}
              </>
            ) : (
              // Tampilan Kartu
              <>
                <div className="space-y-4">
                  <div className="text-sm text-gray-600">
                    Halaman : {renderValue(datahome.data?.current_page)}
                  </div>
                  {datahome.data?.data?.map((field) => (
                    <div
                      key={field.id}
                      className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition"
                    >
                      <p className="text-xs text-gray-400">
                        Nomor : {renderValue(field.no_peraturan)}
                      </p>
                      <Link to={`/detail-produk-hukum/${field.idph}`}>
                        <h2 className="text-base font-bold text-gray-900 hover:text-red-600 transition">
                          {renderValue(field.content)}
                        </h2>
                      </Link>
                      <div className="flex flex-wrap items-center gap-3 mt-2">
                        <span className="text-xs text-gray-400">
                          Tahun {renderValue(field.tahun_diundang)}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                {/* Pagination untuk kartu */}
                <div className="flex justify-center mt-6">
                  <nav aria-label="Page navigation">
                    <ul className="flex items-center -space-x-px text-sm">
                      <li>
                        <a
                          href="#"
                          className="px-3 py-2 rounded-l-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500"
                        >
                          Previous
                        </a>
                      </li>
                      {datahome.data?.links?.map((link, idx) => {
                        const label = link.label;
                        if (label !== 'pagination.previous' && label !== 'pagination.next') {
                          return (
                            <li key={idx}>
                              <a
                                href="#"
                                onClick={() => handleSearchPageNext(label)}
                                className={`px-3 py-2 border border-gray-200 bg-white hover:bg-gray-50 ${dataToDisplay.current_page === label
                                    ? 'bg-red-600 text-white hover:bg-red-700'
                                    : 'text-gray-500'
                                  }`}
                              >
                                {renderValue(label)}
                              </a>
                            </li>
                          );
                        }
                        return null;
                      })}
                      <li>
                        <a
                          href="#"
                          className="px-3 py-2 rounded-r-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500"
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </>
            )}
          </div>

          {/* Tombol close */}
          <div className="flex justify-end mt-4 pt-3 border-t border-gray-200">
            <button
              onClick={closeModal}
              className="px-6 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-lg transition"
            >
              Tutup
            </button>
          </div>
        </div>
      </Modal>
    </nav>
  );
}

export default NavbarTop;